import { Stack } from '@mui/material';
import React from 'react';
import FootnoteRenderer from '../FootnoteRenderer';
import PropertyCardGroup from '../PropertyCardGroup';
import StyledSection from '../styles/StyledSection';
import ImageCarouselHeadings from './ImageCarouselHeadings';
import ImageCarouselItemRow from './ImageCarouselItemRow';
import { ImageCarouselProps } from './imageCarouselTypes';

export type {
  CarouselItem,
  CarouselItemContent,
  ImageCarouselContent,
  ImageCarouselProps,
  MediaURL,
} from './imageCarouselTypes';

export default function ImageCarousel({
  items,
  heading,
  id,
  tone = 'tone1',
  footnotes,
  forceExpanded,
  modelId,
  printMode,
  preventImageCrop,
  getVideoPlaybackUrl,
}: ImageCarouselProps) {
  if (!items?.length) {
    return (
      <StyledSection noSidePaddingFrom="xs" tone={tone}>
        <div className="empty">This section is missing required content.</div>
      </StyledSection>
    );
  }
  return (
    <Stack sx={{ pt: 0 }} id={id} className="image-carousel">
      <ImageCarouselHeadings heading={heading} tone={tone} />
      <PropertyCardGroup
        noSpacing
        key={`${modelId}-group`}
        showExpandAll={items.length > 1}
        forceExpanded={forceExpanded}
        footnotes={<FootnoteRenderer footnotes={footnotes} tone={tone} />}
      >
        {items.map((item, index) => (
          <ImageCarouselItemRow
            key={index}
            item={item}
            index={index}
            printMode={printMode}
            preventImageCrop={preventImageCrop}
            footnotes={footnotes}
            itemsCount={items.length}
            getVideoPlaybackUrl={getVideoPlaybackUrl}
          />
        ))}
      </PropertyCardGroup>
    </Stack>
  );
}
